import { ColDef } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import { utilizationAlertTypeValueGetter } from "./utils/valueGetters/utilizationAlertTypeValueGetter";
import { getAlertsNameColumnDef } from "../common/columnDefs/alertsNameColumnDef";
import { getAlertsThresholdColumnDef } from "../common/columnDefs/alertsThresholdColumnDef";
import { getAlertsCreatedByColumnDef } from "../common/columnDefs/alertsCreatedByColumnDef";
import { getAlertsModifiedByColumnDef } from "../common/columnDefs/alertsModifiedByColumnDef";
import { agGridEmptyColumnToFitEmptySpace } from "../../../../common/ag-grid/utils/constants/agGridEmptyColumnToFitEmptySpace";
import { getAlertsNotificationMethodColumnDef } from "../common/columnDefs/alertsNotificationMethodColumnDef";
import { getAlertsActionsColumnDef } from "../common/columnDefs/alertsActionsColumnDef";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { UtilizationAlertDataGridDataType } from "@/store/alerts/utils/types/types";
import { utilizationAlertTypeTitles } from "@/components/pages/budgets-and-alerts/components/drawer/budget-alert-create-edit-drawer/components/utilization/utils/constants/constants";
import { ProviderIcon } from "@/components/common/ProviderIcon";
import { getProviderName } from "@/utils/helpers/providers/getProviderName";

const alertsNameColumnDef =
  getAlertsNameColumnDef<UtilizationAlertDataGridDataType>();
const alertsThresholdColumnDef =
  getAlertsThresholdColumnDef<UtilizationAlertDataGridDataType>();
const alertsCreatedByColumnDef =
  getAlertsCreatedByColumnDef<UtilizationAlertDataGridDataType>();
const alertsModifiedByColumnDef =
  getAlertsModifiedByColumnDef<UtilizationAlertDataGridDataType>();
const alertsNotificationMethodColumnDef =
  getAlertsNotificationMethodColumnDef<UtilizationAlertDataGridDataType>();
const alertsActionsColumnDef =
  getAlertsActionsColumnDef<UtilizationAlertDataGridDataType>();

export const alertsUtilizationGridColumnDefs: ColDef<UtilizationAlertDataGridDataType>[] =
  [
    alertsNameColumnDef,
    {
      field: "based_on",
      headerName: "Alert Type",
      minWidth: 150,
      width: 230,
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<UtilizationAlertDataGridDataType>) => {
        if (!data) {
          return;
        }

        return (
          <TypographyWithTooltip
            variant="inherit"
            title={utilizationAlertTypeTitles.get(data.based_on)}
          />
        );
      },
      valueGetter: utilizationAlertTypeValueGetter,
    },
    {
      field: "provider",
      headerName: "Cloud Provider",
      minWidth: 100,
      width: 150,
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<UtilizationAlertDataGridDataType>) => {
        if (!data) {
          return;
        }

        return (
          <Stack direction="row" spacing={1} alignItems="center">
            <ProviderIcon provider={data.provider} />
            <Typography variant="body2">
              {getProviderName(data.provider, { title: true })}
            </Typography>
          </Stack>
        );
      },
      valueGetter: ({ data }) =>
        data?.provider
          ? getProviderName(data?.provider, { title: true })
          : undefined,
    },
    alertsThresholdColumnDef,
    alertsCreatedByColumnDef,
    alertsModifiedByColumnDef,
    alertsNotificationMethodColumnDef,
    agGridEmptyColumnToFitEmptySpace,
    alertsActionsColumnDef,
  ];
